import { ModalWindow, Spinner } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { ComplaintItem } from './ComplaintItem';
import { getSelectedComplaint } from './helpers';
import * as styles from './index.css';
import { IComplaint } from '../../../../api/complaint';
import { ComplaintFeedbackFormContainer } from '../../../../components/complaint/feedback_form/container';
import { EFeedbackComplaint } from '../../../../store/complaint/feedback_complaint';
import { getLastArrayItem, isArrayWithItems } from '../../../../utils';
import { trackFeedbackComplainSelect, trackFeedbackSucceed } from '../../tracking';

export interface IComplaintProps {
  complaints: IComplaint[] | null;
  errorMessage: string | null;
  isComplaintAdded: boolean;
  isLoading: boolean;
  isOpen: boolean;
  sendFeedbackStatus: EFeedbackComplaint;
  offer: IOfferSchema;

  resetComplaintState(): void;
  onClose(): void;
  getComplaints(category: number): void;
}

interface IComplaintState {
  selectionTree: number[];
  selected: number | undefined;
}

export class Complaint extends React.PureComponent<IComplaintProps, IComplaintState> {
  public state: IComplaintState = {
    selected: undefined,
    selectionTree: [],
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IComplaintProps) {
    if (this.props.isOpen !== nextProps.isOpen && nextProps.isOpen) {
      this.props.resetComplaintState();
      this.setState({
        selected: undefined,
        selectionTree: [],
      });
    }

    if (this.props.isComplaintAdded !== nextProps.isComplaintAdded && nextProps.isComplaintAdded) {
      trackFeedbackSucceed();
    }
  }

  public componentDidMount() {
    const { getComplaints, offer } = this.props;

    if (!isArrayWithItems(offer.categoriesIds)) {
      return;
    }

    const categoryId = getLastArrayItem<number>(offer.categoriesIds);

    if (categoryId) {
      getComplaints(categoryId);
    }
  }

  public render() {
    const { isOpen, onClose } = this.props;

    return (
      <ModalWindow
        open={isOpen}
        onClose={onClose}
        content={<div className={styles['body']}>{this.renderContent()}</div>}
      />
    );
  }

  private renderContent = () => {
    const { complaints, errorMessage, isComplaintAdded, isLoading, sendFeedbackStatus, onClose } = this.props;

    if (isComplaintAdded && sendFeedbackStatus !== EFeedbackComplaint.success) {
      return (
        <div onClick={this.handleClickOnContainer}>
          <ComplaintFeedbackFormContainer inPopupRender handleOutsideClick={onClose} />
        </div>
      );
    }

    if (isLoading) {
      return (
        <div className={classNames([styles['container'], styles['preloader-wrapper']])}>
          <Spinner size={50} />
        </div>
      );
    }

    if (errorMessage) {
      return (
        <div className={styles['container']} onClick={this.handleClickOnContainer}>
          {errorMessage}
        </div>
      );
    }

    if (!isArrayWithItems(complaints)) {
      return null;
    }

    const { selectionTree } = this.state;

    return (
      <ComplaintItem
        selectionTree={selectionTree}
        complaints={complaints}
        selected={this.state.selected}
        onClickOnContainer={this.handleClickOnContainer}
        onClickOnPrevButton={this.handleClickOnPrevButton}
        onSelect={this.handleSelect}
      />
    );
  };

  private handleClickOnContainer = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  private handleSelect = (index: number, isDropdown?: boolean) => {
    const { selectionTree, selected } = this.state;
    const { complaints } = this.props;

    if (selected === index) {
      return;
    }

    if (isDropdown) {
      this.setState(
        {
          selected: index,
        },
        () => {
          const complaint = getSelectedComplaint(complaints, selectionTree);
          if (complaint) {
            trackFeedbackComplainSelect(selectionTree.length + 1, complaint.items[index].complaintOnSiteId);
          }
        },
      );

      return;
    }

    this.setState(
      {
        selected: undefined,
        selectionTree: selectionTree.concat(index),
      },
      () => {
        const complaint = getSelectedComplaint(complaints, selectionTree);
        if (complaint) {
          trackFeedbackComplainSelect(selectionTree.length + 1, complaint.items[index].complaintOnSiteId);
        }
      },
    );
  };

  private handleClickOnPrevButton = () => {
    this.setState({
      selected: undefined,
      selectionTree: this.state.selectionTree.slice(0, this.state.selectionTree.length - 1),
    });
  };
}
